import React from "react";
import PropTypes from "prop-types";

// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import AddIcon from "@material-ui/icons/Add";
import { Button } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";

// theme components
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";

// custom components
import ScaffoldBase from "components/CustomScaffold/ScaffoldBase";

// React-Redux reducers
import { connect } from "react-redux";

import {
  fetchRichieste,
  fetchRichiesta,
  deleteRichiesta
} from "actions/richieste";

import { compose } from "redux";
import { withRouter } from "react-router";

class RichiesteCliente extends React.Component {

  state = {
    /*filtro: {
      Nome: { 'campo': 'Nome', 'valore': ''},
      Cognome: { 'campo': 'Cognome', 'valore': ''},
    }*/
  }

  componentDidMount() {
    const { loadRichieste, utenteLoggato} = this.props
      
    if (utenteLoggato["Azienda"])
      loadRichieste([ { 'campo': 'Richiedente', 'operatore' : '=', 'valore': utenteLoggato['Azienda']._id } ]);
  }

  // funzione utilizzata per spostarsi nella pagina di inserimento nuova richiesta
  aggiungiRichiesta() {
    const { history } = this.props

    history.push('/dashboard/richieste/add')
  }

  // cancella la richiesta
  cancellaRichiesta(id) {
    const { delRichiesta } = this.props
    Promise.resolve()
    .then( () => delRichiesta(id) )
    .then(() => {
      const { loadRichieste, utenteLoggato } = this.props

      if (utenteLoggato["Azienda"])
      loadRichieste([ { 'campo': 'Richiedente', 'operatore' : '=', 'valore': utenteLoggato['Azienda']._id } ])
    })
  }

  apriModificaRichiesta(id) {
    const { history } = this.props

    history.push('/dashboard/richieste/'+id+'/edit')
  }

  // applico il filtro
  /*handleFilterBy = (e) => {
    const proprieta = e.target.name
    const valore = e.target.value

    const { filtro } = this.state
    const { loadDipendenti, utenteLoggato } = this.props

    filtro[proprieta] = { 'campo': proprieta, 'valore': valore }

    this.setState({ filtro })

    let filtroLoad = [
      { 'campo': 'Azienda', 'valore': utenteLoggato['Azienda']._id}
    ]

    Object.keys(filtro).forEach( (k) => {
      filtroLoad.push(filtro[k])
    })

    loadDipendenti(filtroLoad)

  }*/

  render() {
    const { richieste, classes } = this.props;
    //const { filtro } = this.state
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Button onClick={() => this.aggiungiRichiesta()} style={{background: /*"linear-gradient(60deg, #7d6960, #3e2a23)"*/"linear-gradient(60deg, #022f65, #004494)", color: "#ffffff"}} variant="contained"><AddIcon />
              Aggiungi nuova richiesta
            </Button>
          </GridItem>
        </GridContainer>
        <ScaffoldBase title="Lista richieste" subtitle="Dettaglio richieste">
          { richieste && richieste.length > 0 &&
          <GridItem xs={12} sm={12} md={12}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Azione</TableCell>
                  <TableCell>Giorno</TableCell>
                  <TableCell>Oggetto</TableCell>
                  <TableCell>Descrizione</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                    richieste && richieste.map( (richiesta) => 
                      <TableRow key={richiesta._id}>
                        <TableCell>
                            <Tooltip
                              id="tooltip-top"
                              title="Modifica"
                              placement="top"
                              classes={{ tooltip: classes.tooltip }}
                            >
                              <IconButton
                                aria-label="Edit"
                                className={classes.tableActionButton}
                              >
                                <Edit
                                  className={
                                    classes.tableActionButtonIcon + " " + classes.edit
                                  }
                                  onClick={() => this.apriModificaRichiesta(richiesta._id)}
                                />
                              </IconButton>
                            </Tooltip>
                            <Tooltip
                              id="tooltip-top-start"
                              title="Elimina"
                              placement="top"
                              classes={{ tooltip: classes.tooltip }}
                            >
                              <IconButton
                                aria-label="Close"
                                className={classes.tableActionButton}
                              >
                                <Close
                                  className={
                                    classes.tableActionButtonIcon + " " + classes.close
                                  }
                                  onClick={() => this.cancellaRichiesta(richiesta._id)}
                                />
                              </IconButton>
                            </Tooltip>
                        </TableCell>
                        <TableCell>{new Date(richiesta["Giorno"]).toLocaleDateString('it-IT', { month: '2-digit', day: '2-digit', year: 'numeric' })}</TableCell>
                        <TableCell>{richiesta["Oggetto"]}</TableCell>
                        <TableCell>{richiesta["Descrizione"]}</TableCell>
                      </TableRow>
                    ) 
                  }
              </TableBody>
            </Table>
          </GridItem>
          }

          { (!richieste || richieste.length <= 0) && 
            <GridItem>
              <p>Richieste non disponibili</p>
            </GridItem> 
          }
        </ScaffoldBase>
      </div>
    );
  }
}

RichiesteCliente.propTypes = {
  classes: PropTypes.object.isRequired
};

function mapDispatchToProps( dispatch ) {
  return {
    loadRichieste: (filtro) => dispatch(fetchRichieste(filtro)),
    setRichieste: (id) => dispatch(fetchRichiesta(id)),
    delRichiesta: (id) => dispatch(deleteRichiesta(id))
  }
}

function mapStateToProps({ richieste, authentication }) {
  return { 
    richieste: richieste.items,
    utenteLoggato: authentication.user
  };
}

export default compose(
  withStyles(dashboardStyle),
  connect(mapStateToProps, mapDispatchToProps)
)(withRouter(RichiesteCliente));
